import { Seo } from "../components/site/Seo";
import { Hero } from "../components/home/Hero";
import { Positioning, ServiceLines, Process, WhyUs, Audiences } from "../components/home/HomeSections";
import { ClosingCta } from "../components/site/Blocks";
import { SITE } from "../data/site";

const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Trusted Leap",
  description: SITE.description,
  url: typeof window !== "undefined" ? window.location.origin : "",
};

export default function Home() {
  return (
    <>
      <Seo
        description="Trusted Leap connects businesses with vetted independent professionals across auditing, consulting, advisory, tax and law — a curated B2B expert marketplace for complex challenges."
        path="/"
        jsonLd={ORG_LD}
      />
      <Hero />
      <Positioning />
      <ServiceLines />
      <Process />
      <WhyUs />
      <Audiences />
      <ClosingCta />
    </>
  );
}
